// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"b2cd1c9e","256":"75d4e868","374":"36ba708b","453":"a1053275","591":"248f4f7f","883":"c120dcdc","993":"e06c7e79"}[chunkId] + ".chunk.js";
};